module.exports = __webpack_public_path__ + "img/selected3-min.f6387d01.png";